import Cookies from 'js-cookie';

import { sendTrackingEvent, TRACKING_EVENTS } from '../analytics/trackingEvent';
import { markUserHasAccount } from './returningUser';

export const IDP_LOGIN_SUCCESS_COOKIE = 'st-idp-login';

const methodFromIdpId = idpId => {
  if (idpId === 'google') {
    return 'Google';
  }
  if (idpId === 'facebook') {
    return 'Facebook';
  }
  return idpId;
};

/**
 * After a successful existing-user IdP login, loginWithIdp.js sets a short-lived
 * cookie. Consume it once on the next app load: fire GA4 `login` (success) and
 * mark this device as a returning user.
 */
export const consumeIdpLoginSuccess = () => {
  if (typeof window === 'undefined') {
    return null;
  }
  const idpId = Cookies.get(IDP_LOGIN_SUCCESS_COOKIE);
  if (!idpId) {
    return null;
  }
  Cookies.remove(IDP_LOGIN_SUCCESS_COOKIE, { path: '/' });
  markUserHasAccount();
  const method = methodFromIdpId(idpId);
  sendTrackingEvent({
    name: TRACKING_EVENTS.LOGIN,
    parameters: { method },
  });
  return method;
};
